// extracted by mini-css-extract-plugin
export var component = "FooterMenu-module--component--ugG8l";
export var list = "FooterMenu-module--list--QPvRS";